import { useContext } from 'react';
import { ProductContext } from "./ProductCard";

import styles from '../styles/styles.module.css'


export interface Props {
    className?: string
    sku?: string,
    activeClass?: string;
    style?: React.CSSProperties
}

export const ProductSKU = ({ sku, className, style }: Props) => {

    const { product } = useContext(ProductContext)
    return (
        <span
            className={`${styles.productDescription} ${className}`}
            style={style}
        >
            {sku ? sku : product.sku}
        </span>
    );
}